import React from 'react'

import SplitPanel from './SplitPanel'

import styles from '../theme/BBFCSplitPanel.module.scss'

const BBFCSplitPanel = (props) => <SplitPanel {...props} styles={styles} />

export default BBFCSplitPanel
